import React, { Component, ReactNode } from 'react';
import { Calendar, CalendarChangeParams } from 'primereact/calendar';
import CustomTimePickerFooter from './CustomTimePickerFooter';
import { FormicaTimePickerDate } from './TimePickerDomain';
import DateFactory from 'util/DateFactory';

class CustomAbsoluteTimePicker extends Component<Props> {
  public render(): ReactNode {
    const { date, setDate } = this.props;
    return (
      <div className={'flex flex-col items-center justify-start w-full h-full'}>
        <Calendar style={{ height: '380px !important' }} value={date.value || DateFactory.today()} onChange={this.setCalendarDate} showWeek inline />
        <div className={'flex w-full items-center justify-end self-end justify-self-end pb-2'}>
          <CustomTimePickerFooter date={date} setDate={setDate} />
        </div>
      </div>
    );
  }

  private setCalendarDate = (e: CalendarChangeParams) => {
    const { setDate } = this.props;
    const newDate = e.value as Date;
    setDate({
      value: newDate,
      label: newDate.toLocaleString(),
      type: 'Absolute',
    });
  };
}

interface Props {
  date: FormicaTimePickerDate;
  setDate: (date: FormicaTimePickerDate) => void;
}

export default CustomAbsoluteTimePicker;
